module.exports = __webpack_public_path__ + "static/phone-slide-2-en-8e37200c8b60274f786fdc26ba8aeed2.png";